const lengthIsGreaterThanZero = (value: string) => {
  return value.length > 0;
};

export const isValidEmail = (value: string) => {
  // https://regexr.com/3e48o
  return !!value?.toLowerCase().match(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/)?.[0];
};

export const validateFormField = (field: HTMLInputElement) => {
  const { type, value } = field;
  switch (type) {
    case 'email':
      return isValidEmail(value);
    default:
      return lengthIsGreaterThanZero(value);
  }
};

export default validateFormField;
